import { useSelector } from 'react-redux';

import { RootState } from '@v2/store';
import { IShop } from './shop.store';

export function useShop(): IShop {
    return useSelector((state: RootState) => state.shop);
}
